import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_SKILLS_ACTION_TYPE } from '../actions';

const initialState = {
  skills: [],
  templates: [],
};

const aiSkillsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_SKILLS_ACTION_TYPE.GET_AI_SKILLS:
        draft.skills = payload;
        break;

      case AI_SKILLS_ACTION_TYPE.GET_AI_SKILL_TEMPLATES:
        draft.templates = payload;
        break;

      case AI_SKILLS_ACTION_TYPE.CREATE_AI_SKILL:
        draft.skills = [...state.skills, payload];
        break;

      case AI_SKILLS_ACTION_TYPE.UPDATE_AI_SKILL:
        draft.skills = state.skills.map(skill => (skill.id === payload.id ? payload : skill));
        break;

      case AI_SKILLS_ACTION_TYPE.DELETE_AI_SKILL:
        draft.skills = state.skills.filter(({ id }) => id !== payload);
        break;

      case AI_SKILLS_ACTION_TYPE.CLONE_AI_SKILL:
        draft.skills = [...state.skills, payload];
        break;

      case AI_SKILLS_ACTION_TYPE.ENABLE_AI_SKILL:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: true } : template,
        );
        break;

      case AI_SKILLS_ACTION_TYPE.DISABLE_AI_SKILL:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: false } : template,
        );
        break;

      case AI_SKILLS_ACTION_TYPE.RESET_AI_SKILLS_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiSkillsReducer;
